import tpl from './browser-error.tpl.html';

import './browser-error.scss';

/**
 * Simple component showing an error to user if their browser is too old.
 */
class BrowserErrorComponent {
  constructor() {
    'ngInject';
  }
}

const config = {
  templateUrl: tpl,
  controller: BrowserErrorComponent,
  bindings: {
    browser: '@'
  }
};

const mod = angular.module('app.common.browserError', [])

.component('browserErrorStripe', config);

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/components/browser-error.component.js